import Benefits_section from '../../component/Services_Component/Benefits_section';
import useMetaTags from '../../hooks/useMetaTags';
import { BenefitSection, LargeData, roleWriting, AssistanceSection, FAQ } from '../../Data/All_Services_Data/virtualAssistantServiceData';
import Handle_Largedata_section from '../../component/Services_Component/Handle_Largedata_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';

const VirtualAssistantService = () => {
  useMetaTags({
    title:
      "Boost Efficiency with Expert Virtual Assistant Services Today",
    description:
      "Streamline your business with professional Virtual Assistant Services. From admin to scheduling, get reliable support and focus on what matters most to your success.",
    keywords:
      "virtual assistant services, Virtual Assistant, virtual administrative assistant, virtual assistant service, virtual personal assistant, hire a virtual assistant, virtual assistant companies, virtual marketing assistant, virtual administrative assistant, virtual executive assistant, ai assistant, virtual secretary, ai personal assistant", });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Get More Done with a Virtual Assistant
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/virtual.jpg"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  Managing productivity and focusing on essentials can be hard in our digital world where time rushes by. A virtual assistant services helps you finish tasks that eat too much time, so you keep your eyes on important business goals. No matter if you are running your own company, building a new startup, or handling busy work life, virtual assistants support you daily from anywhere in the world. They organize your meetings, run your social media, and do many jobs that make everyday work less messy. Having a virtual assistant quickly turns into your shortcut for staying efficient and getting more work finished.
                </p>
              </div>
            </div>

            <Benefits_section data={BenefitSection} />

            <Handle_Largedata_section LargeData={LargeData} />

            <Role_writing data={roleWriting} />

            <Assistance_section data={AssistanceSection} />

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  )
}

export default VirtualAssistantService